import { inject } from '@angular/core';
import { UsersService, VeterinarianDto } from '@anihis/core/data-access';
import {
  patchState,
  signalStore,
  withMethods,
  withState,
  withHooks,
} from '@ngrx/signals';
import { catchError, finalize, tap, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { LoadingStatus } from '../../enums/loading';

type UploadDocumentDialogState = {
  data: VeterinarianDto[] | undefined;
  correctPin: boolean | undefined;
  status: LoadingStatus | undefined;
  submitStatus: LoadingStatus | undefined;
};

const initialState: UploadDocumentDialogState = {
  data: undefined,
  correctPin: undefined,
  status: undefined,
  submitStatus: undefined,
};

export const UploadDocumentDialogStore = signalStore(
  withState(initialState),
  withMethods((store, usersService = inject(UsersService)) => {
    return {
      fetchData() {
        patchState(store, { status: LoadingStatus.Loading });

        return usersService.usersVeterinariansGet(false).pipe(
          tap((x) => {
            patchState(store, { data: x.veterinans });
          }),

          finalize(() =>
            patchState(store, {
              status: LoadingStatus.Loaded,
            }),
          ),
        );
      },
      validateVetPin(veterinarianUid: string, pin: string) {
        patchState(store, { submitStatus: LoadingStatus.Loading });

        return usersService
          .usersVeterinariansCheckPinGet(veterinarianUid, pin)
          .pipe(
            tap((x: any) => {
              patchState(store, {
                correctPin: x.correctPin,
                submitStatus: x.correctPin
                  ? LoadingStatus.Loaded
                  : LoadingStatus.Error,
              });
            }),
            map((x: any) => !!x.correctPin),
            catchError((err) => {
              patchState(store, { submitStatus: LoadingStatus.Loaded });
              return throwError(() => err);
            }),
          );
      },
    };
  }),
  withHooks({
    onInit(store) {
      store.fetchData().subscribe();
    },
  }),
);
